import React, { useState, useContext, useEffect, useRef } from 'react'
import { withRouter } from 'react-router-dom'
import {
  Layout,
  Modal,
  message,
  Icon,
  Dropdown,
  Menu,
  Radio,
  Divider,
  Select,
  PageHeader,
  Button as Btn
} from 'antd'
import { H4 } from '../override/Typography'
import Button from '../../components/override/Button'
import { useTranslation } from 'react-i18next'
import { Calendar, Badge, Empty, Table } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import VaultContext from '../../contexts/VaultContext'
import { onError } from '../../lib/sentry'
import AddEventModal from './AddEventModal'
import EventDetails from './EventDetails'
import EventList from './EventList'
import { fetchEvents } from './../../features/events/eventsSlice'
import ExportDropdown from '../assets-liabilities/ExportDropdown'
import './Calendar.scss'
import moment from 'moment'
import {
  unlinkItemFromLinkedList,
  uploadEncryptedData,
  getRecords
} from '../../lib/pouchDb'
import { DATE_FORMAT, RECURRING } from '../../share/Constants'
import PouchDB from 'pouchdb'
import api from '../../lib/api'
import '../common/Common.scss'
import EditDeleteEventTypeModal from '../modals/EditDeleteEventTypeModal'
import { EDIT_DELETE_EVENT_TYPE } from './../../share/Constants'
import { uniq } from 'lodash'
import { fetchLinkedEvents } from './../../features/events/linkedEventsSlice'
import { eventColumns } from './eventHelpers'
import { ThemeContext } from 'styled-components'
import { useMutation } from 'react-apollo-hooks'
import { createS3Change } from '../../graphql/mutations'
import { exportHTMLToPng, checkPermission } from '../../share/helpers'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { fetchUser } from './../../features/user/userSlice';

const { Content } = Layout

function CalendarComponent() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const theme = useContext(ThemeContext)
  const { userId, masterKey, fullName, isReadonly, recordIds, permissions } =
    useContext(VaultContext)
  const { activeEvents } = useSelector(state =>
    isReadonly ? state.otherEvents : state.events
  )
  const { activeContacts } = useSelector(state =>
    isReadonly ? state.otherContacts : state.contacts
  )
  // const { activeAssetsLiabilities } = useSelector(
  //   state => state.assetsLiabilities
  // )
  const { activePasswords } = useSelector(state => state.passwords)
  const { activeFiles } = useSelector(state => state.documents)
  const [isListModalVisible, setIsListModalVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isEventModalVisible, setIsEventModalVisible] = useState(false)
  const [isDetailEventModal, setIsDetailEventModal] = useState(false)
  const [isEditMode, setIsEditMode] = useState(false)
  const [viewMode, setViewMode] = useState('grid')

  const [selectedValue, setSelectedValue] = useState('')
  const [eventDetails, setEventDetails] = useState({})
  const [changeMonth, setChangeMonth] = useState(0)
  const [isPopUpScroll, setIsPopUpScroll] = useState(false)
  const [data, setData] = useState([])
  const [deleteTypeVisible, setDeleteTypeVisible] = useState(false)
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'))
  const [type, setType] = useState()
  const [small, setSmall] = useState(false)
  const [size, setSize] = useState('default')

  const calendarRef = useRef()
  const [modeCalendar, setModeCalendar] = useState('month')

  const [addS3Change] = useMutation(createS3Change)

  useEffect(() => {
    dispatch(fetchEvents(userId, masterKey))
  }, [userId, masterKey, dispatch])

  useEffect(() => {
    if (!isMdUp) {
      setSmall(true)
      setSize('small')
    } else {
      setSmall(false)
      setSize('default')
    }
  }, [isMdUp])

  const handleClose = () => {
    setIsListModalVisible(false)
    setIsEventModalVisible(false)
    setIsEditMode(false)
    setEventDetails({})
    setData([])
    setType()
  }

  const showDetailEventModal = record => {
    setIsLoading(true)
    setTimeout(() => {
      setIsLoading(false)
    }, 1500)
    setEventDetails(record)
    setIsDetailEventModal(true)
  }

  const showEventsByDate = value => {
    setData(getEventByDate(value))
    setIsListModalVisible(true)
  }

  const showEventsByMonth = value => {
    setData(getEventByMonth(value))
    setIsListModalVisible(true)
  }

  const onPanelChange = (value, mode) => {
    setModeCalendar(mode)
  }

  const onSelect = value => {
    setSelectedValue(value)
    if (modeCalendar === 'month') {
      getEventByDate(value).length > 0
        ? showEventsByDate(value)
        : showAddEventModal()
    } else {
      getEventByMonth(value).length > 0
        ? showEventsByMonth(value)
        : showAddEventModal()
    }
  }

  const showAddEventModal = () => {
    setIsEventModalVisible(true)
    setIsListModalVisible(false)
  }

  const handleReturn = () => {
    setIsEventModalVisible(false)
    setIsListModalVisible(true)
    setIsEditMode(false)
  }

  const getEventByDate = date => {
    return activeEvents.filter(
      item =>
        moment(item.date).format(DATE_FORMAT) ===
          moment(date).format(DATE_FORMAT) &&
        (!isReadonly || recordIds.includes(item._id))
    )
  }

  const dateCellRender = value => {
    const listData = getEventByDate(value)

    return (
      <ul className="events" onClick={() => showEventsByDate(value)}>
        {listData.map(item => (
          <li key={`${item.id}_${item.date}`}>
            <Badge color={item.color || 'red'} text={item.description} />
          </li>
        ))}
      </ul>
    )
  }

  const getEventByMonth = value => {
    return activeEvents.filter(
      item =>
        moment(item.date).month() === value.month() &&
        moment(item.date).year() === value.year() &&
        (!isReadonly || recordIds.includes(item._id))
    )
  }

  const monthCellRender = value => {
    const listData = getEventByMonth(value)

    return (
      <ul className="events" onClick={() => showEventsByMonth(value)}>
        {listData.map(item => (
          <li key={item.id.concat(item.date)}>
            <Badge color={item.color || 'red'} text={item.description} />
          </li>
        ))}
      </ul>
    )
  }

  const handleDeleteItem = item => {
    Modal.confirm({
      title: t('CONFIRM_DELETE'),
      content: <>{t('CONFIRM_DELETE_ITEM_MSG')}</>,
      async onOk() {
        if (item.recurringValue === RECURRING.NONE) {
          deleteItems(item)
        } else {
          setEventDetails(item)
          setDeleteTypeVisible(true)
        }
      },
      onCancel() {}
    })
  }

  const deleteItems = async (item, type = null) => {
    try {
      const response = await api.getEvents(userId)
      const lstEvents = response.data?.events || []
      let newReminderEvents
      if (!type) {
        newReminderEvents = lstEvents.map(e =>
          e.id === item._id ? { ...e, deleted: true } : e
        )
      } else {
        if (type === EDIT_DELETE_EVENT_TYPE.THIS_EVENT) {
          newReminderEvents = lstEvents.map(e =>
            e.id === item._id && e.date === item.date
              ? { ...e, deleted: true }
              : e
          )
        } else if (type === EDIT_DELETE_EVENT_TYPE.THIS_AND_FOLLOWING_EVENTS) {
          newReminderEvents = lstEvents.map(e =>
            e.id === item._id && e.date >= item.date
              ? { ...e, deleted: true }
              : e
          )
        } else {
          newReminderEvents = lstEvents.map(e =>
            item.parentId
              ? e.id === item.parentId ||
                e.parentId === item.parentId ||
                e.id === item._id ||
                e.parentId === item._id
                ? { ...e, deleted: true }
                : e
              : e.id === item._id || e.parentId === item._id
              ? { ...e, deleted: true }
              : e
          )
        }
      }

      await api.updateEvents(
        userId,
        JSON.stringify({
          events: newReminderEvents
        })
      )

      //get events from PouchDB
      if (type === EDIT_DELETE_EVENT_TYPE.ALL_EVENTS || !type) {
        const events = await getRecords(userId, 'events', masterKey)
        const deletedItems =
          events?.filter(
            e =>
              !uniq(
                newReminderEvents.filter(ne => ne.deleted).map(ne => ne.id)
              ).includes(e._id)
          ) || []

        if (deletedItems?.length) {
          await Promise.all(
            deletedItems.map(async item => {
              if (item.contacts?.length) {
                const contactsDb = new PouchDB(`${userId}_contacts`)
                contactsDb.crypto(masterKey)
                await unlinkItemFromLinkedList(
                  item._id,
                  'events',
                  item.contacts,
                  contactsDb
                )
                await uploadEncryptedData(contactsDb, userId, 'contacts')
              }

              if (item.documents?.length) {
                const documentsDb = new PouchDB(`${userId}_documents`)
                documentsDb.crypto(masterKey)
                await unlinkItemFromLinkedList(
                  item._id,
                  'events',
                  item.documents,
                  documentsDb
                )
                await uploadEncryptedData(documentsDb, userId, 'documents')
              }

              if (item.assetsLiabilities?.length) {
                const db = new PouchDB(`${userId}_assetsLiabilities`)
                db.crypto(masterKey)
                await unlinkItemFromLinkedList(
                  item._id,
                  'events',
                  item.assetsLiabilities,
                  db
                )
                await uploadEncryptedData(db, userId, 'assetsLiabilities')
              }

              if (item.passwords?.length) {
                const db = new PouchDB(`${userId}_passwords`)
                db.crypto(masterKey)
                await unlinkItemFromLinkedList(
                  item._id,
                  'events',
                  item.passwords,
                  db
                )
                await uploadEncryptedData(db, userId, 'passwords')
              }
            })
          )

          localStorage.setItem('NotReload', true)
          addS3Change({
            variables: {
              message: 'assetsLiabilities, documents, contacts, events, passwords',
              userId: userId
            }
          })
        }
      }

      message.success(t('SUCCESSFULLY_DELETED'))
      dispatch(fetchEvents(userId, masterKey))
      dispatch(fetchLinkedEvents(userId, masterKey))
      dispatch(fetchUser(userId))
      setIsListModalVisible(false)
      setIsDetailEventModal(false)
      setEventDetails({})
      setData([])
    } catch (err) {
      message.error(t('FAILED_TO_DELETE_ITEM'))
      onError(err)
    }
  }

  const handleEditItem = item => {
    setEventDetails(item)
    if (item.recurringValue === RECURRING.NONE) {
      showAddEventModal()
    } else {
      setDeleteTypeVisible(true)
    }

    setIsEditMode(true)
  }

  const actionsDropdown = item => (
    <Dropdown
      overlay={
        <Menu>
          <Menu.Item
            className="dropdown-button"
            onClick={() => handleEditItem(item)}
          >
            {t('EDIT')}
          </Menu.Item>
          <Menu.Item
            className="dropdown-button"
            onClick={() => handleDeleteItem(item)}
          >
            {t('DELETE')}
          </Menu.Item>
        </Menu>
      }
      placement="bottomRight"
      trigger={['click']}
    >
      <Icon type="ellipsis" />
    </Dropdown>
  )

  const columns = [
    {
      key: 'description',
      dataIndex: 'description',
      title: t('DESCRIPTION'),
      render: (text, record) => (
        <span
          className="item-name"
          onClick={() => showDetailEventModal(record)}
        >
          {record.description}
        </span>
      )
    },
    {
      key: 'date',
      dataIndex: 'date',
      title: t('DATE'),
      render: (text, record) => (
        <span>{moment(record.date).format(DATE_FORMAT)}</span>
      )
    },
    {
      key: 'actions',
      render: (text, record) =>
        (!isReadonly || checkPermission(permissions, record._id)) &&
        actionsDropdown(record),
      width: 46,
      align: 'right'
    }
  ]

  const onWheel = e => {
    if (
      viewMode === 'grid' &&
      !isListModalVisible &&
      !isEventModalVisible &&
      !isDetailEventModal &&
      !deleteTypeVisible &&
      !isPopUpScroll
    ) {
      setSelectedValue('')
      if (e.deltaY < 0) {
        setTimeout(() => {
          setChangeMonth(changeMonth - 1)
        }, 300)
      } else {
        setTimeout(() => {
          setChangeMonth(changeMonth + 1)
        }, 300)
      }
    }
  }

  const onChange = value => {
    setChangeMonth(value.endOf('day').diff(moment().endOf('day'), 'M', true))
  }

  const setDateValue = () => {
    if (selectedValue) {
      return selectedValue
    } else {
      return moment().add(changeMonth, 'M')
    }
  }

  return (
    <Layout
      style={{
        height: '100%',
        padding: '0 20px 20px',
        backgroundColor: '#fff'
      }}
    >
      <PageHeader
        style={{ padding: '10px 0' }}
        title={
          <H4 display="inline-block">
            {viewMode === 'grid' ? t('CALENDAR') : t('EVENTS')}
          </H4>
        }
        extra={
          <>
            {viewMode === 'list' && (
              <ExportDropdown
                style={{ height: 33 }}
                fileName="Events"
                columns={eventColumns(
                  activeContacts,
                  // activeAssetsLiabilities,
                  activeFiles,
                  activePasswords
                )}
                source={activeEvents}
                subTitle="List of Events"
              />
            )}
            {viewMode === 'grid' && (
              <Btn
                size={size}
                onClick={() => {
                  try {
                    exportHTMLToPng(
                      calendarRef.current,
                      theme.white,
                      'Calendar'
                    )
                  } catch (err) {
                    message.error(t('FAILED_TO_EXPORT_TO_PNG'))
                  }
                }}
              >
                {t('EXPORT_TO_PNG')}
              </Btn>
            )}
            {!small && <Divider type="vertical" />}
            <Radio.Group
              size={viewMode === 'list' ? 'default' : size}
              defaultValue={viewMode}
              onChange={e => {
                setViewMode(e.target.value)
                setModeCalendar('month')
              }}
            >
              <Radio.Button value="grid">
                <Icon type="appstore" style={{ fontSize: 16 }} />
              </Radio.Button>
              <Radio.Button value="list">
                <Icon type="bars" style={{ fontSize: 16 }} />
              </Radio.Button>
            </Radio.Group>
            {viewMode === 'grid' && small && (
              <Btn
                size={size}
                onClick={() => {
                  setSelectedValue('')
                  const today = moment()
                  onChange(today)
                }}
              >
                {t('TODAY')}
              </Btn>
            )}
          </>
        }
      />
      <Content onWheel={onWheel}>
        {viewMode === 'grid' && (
          <div ref={calendarRef}>
            <div
              className="title"
              style={{
                width: '100%',
                textAlign: 'center',
                fontSize: 20,
                fontWeight: 'bold',
                marginBottom: 20,
                display: 'none'
              }}
            >
              {fullName} - Calendar
            </div>
            <Calendar
              style={{ maxHeight: 'calc(100vh - 160px)' }}
              monthCellRender={monthCellRender}
              dateCellRender={dateCellRender}
              onSelect={onSelect}
              onPanelChange={onPanelChange}
              onChange={onChange}
              value={setDateValue()}
              headerRender={({ value, type, onChange, onTypeChange }) => {
                const start = 0
                const end = 12
                const monthOptions = []

                const current = value.clone()
                const localeData = value.localeData()
                const months = []
                for (let i = 0; i < 12; i++) {
                  current.month(i)
                  months.push(localeData.monthsShort(current))
                }

                for (let index = start; index < end; index++) {
                  monthOptions.push(
                    <Select.Option className="month-item" key={`${index}`}>
                      {months[index]}
                    </Select.Option>
                  )
                }
                const month = value.month()

                const year = value.year()
                const options = []
                for (let i = year - 10; i < year + 10; i += 1) {
                  options.push(
                    <Select.Option key={i} value={i} className="year-item">
                      {i}
                    </Select.Option>
                  )
                }
                return (
                  <div className={small ? 'nav-small' : 'nav'}>
                    {!small && (
                      <>
                        <Btn
                          size={size}
                          onClick={() => {
                            setSelectedValue('')
                            const today = moment()
                            onChange(today)
                          }}
                        >
                          {t('TODAY')}
                        </Btn>
                        <Divider type="vertical" />
                      </>
                    )}
                    <Select
                      className={small ? 'nav-item' : ''}
                      size={size}
                      dropdownMatchSelectWidth={false}
                      onChange={newYear => {
                        setSelectedValue('')
                        const now = value.clone().year(newYear)
                        onChange(now)
                      }}
                      value={String(year)}
                      onDropdownVisibleChange={open => {
                        open ? setIsPopUpScroll(true) : setIsPopUpScroll(false)
                      }}
                    >
                      {options}
                    </Select>
                    {!small && <Divider type="vertical" />}
                    <Select
                      className={small ? 'nav-item' : ''}
                      size={size}
                      dropdownMatchSelectWidth={false}
                      value={String(month)}
                      onChange={selectedMonth => {
                        setSelectedValue('')
                        const newValue = value.clone()
                        newValue.month(parseInt(selectedMonth, 10))
                        onChange(newValue)
                      }}
                      onDropdownVisibleChange={open => {
                        open ? setIsPopUpScroll(true) : setIsPopUpScroll(false)
                      }}
                    >
                      {monthOptions}
                    </Select>
                    {!small && <Divider type="vertical" />}
                    <Radio.Group
                      className={small ? 'nav-item' : ''}
                      size={size}
                      onChange={e => onTypeChange(e.target.value)}
                      value={type}
                    >
                      <Radio.Button className="bigger" value="month">
                        {t('MONTH')}
                      </Radio.Button>
                      <Radio.Button className="bigger" value="year">
                        {t('YEAR')}
                      </Radio.Button>
                    </Radio.Group>
                  </div>
                )
              }}
            />
          </div>
        )}
        {viewMode === 'list' && (
          <EventList
            handleEditItem={handleEditItem}
            handleClose={handleClose}
            isLoading={isLoading}
            actionsDropdown={actionsDropdown}
            showDetailEventModal={showDetailEventModal}
            eventDetails={eventDetails}
          />
        )}
        <Modal
          title={t('EVENTS')}
          visible={isListModalVisible}
          onCancel={handleClose}
          footer={[
            <Button key="close" onClick={handleClose}>
              {t('CANCEL')}
            </Button>,
            <Button
              key="add"
              type="primary"
              onClick={() => showAddEventModal()}
              disabled={isReadonly}
            >
              {t('ADD')}
            </Button>
          ]}
        >
          {data?.length ? (
            <Table
              rowKey={record => record._id.concat(record.date)}
              columns={columns}
              dataSource={data}
            />
          ) : (
            <Empty />
          )}
        </Modal>

        {/* Event Details */}
        <EventDetails
          isLoading={isLoading}
          handleEditItem={handleEditItem}
          handleDeleteItem={handleDeleteItem}
          visible={isDetailEventModal}
          setVisible={setIsDetailEventModal}
          record={eventDetails}
          isViewMode={isReadonly}
        />

        {/* Add Modal */}
        <AddEventModal
          isEditMode={isEditMode}
          isFullModal={true}
          visible={isEventModalVisible}
          setVisible={setIsEventModalVisible}
          handleClose={handleClose}
          data={data}
          handleReturn={handleReturn}
          eventDetails={eventDetails}
          selectedValue={selectedValue}
          linkedEvents={[]}
          setLinkedEvents={() => {}}
          type={type}
        />
        <EditDeleteEventTypeModal
          visible={deleteTypeVisible}
          setVisible={setDeleteTypeVisible}
          handleOk={isEditMode ? showAddEventModal : deleteItems}
          eventDetails={eventDetails}
          isEditMode={isEditMode}
          type={type}
          setType={setType}
        />
      </Content>
    </Layout>
  )
}

export default withRouter(CalendarComponent)
